import styled from 'styled-components';
import device from '../../mediaQueries';

const ShoppingBag = styled.a`
  background: url('https://d3nn9jcidi1lkh.cloudfront.net/mkt/header/shopping_bag.svg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 17px;
  height: 25px;
  text-decoration: none;
  ${device.desktop`
    width: 25px;
    height: 36px;
  `}
`;

const ShoppingBagText = styled.span`
  margin-top: 8px;
  font-family: 'Avenir', 'Arial', sans-serif;
  color: #000000;
  font-size: 11px;
  font-weight: 300;
  line-height: 15px;
  ${device.desktop`
    margin-top: 10px;
    font-size: 13px;
    line-height: 18px;
  `}
`;
export { ShoppingBag, ShoppingBagText };
